import { IFieldOrder } from './iFieldOrder';

export interface IMyNegotiationsTypesFilters {
  fieldOrder: IFieldOrder | null;
}

class MyNegotiationsTypesFiltersClass implements IMyNegotiationsTypesFilters {
  fieldOrder: IFieldOrder | null;

  constructor(fieldOrder: any) {
    this.fieldOrder = fieldOrder;
  }
}

export default MyNegotiationsTypesFiltersClass;
